import { ReactNode, useState } from "react";
import { Container, Box } from "@mui/material";
import Sidebar from "./SideBar";
import { SIDEBAR_WIDTH } from "../constants";
import "./Layout.scss";
import Topbar from "./Topbar";

function MainContainer({
  children,
  hideHeader = false,
}: {
  children: ReactNode;
  hideHeader?: boolean;
}) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleSidebarToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <Topbar handleSidebarToggle={handleSidebarToggle} />
      <Sidebar
        mobileOpen={mobileOpen}
        handleSidebarToggle={handleSidebarToggle}
      />
      <Box
        className="main_content"
        component="main"
        sx={{
          marginLeft: "auto",
          width: { lg: `calc(100% - ${SIDEBAR_WIDTH}px)` },
        }}
      >
        <Container className="sub-layout" sx={{ paddingTop: 13 }}>
          {children}
        </Container>
      </Box>
    </>
  );
}
export default MainContainer;
